class MobileNavigation {
	constructor() {
		this.nav = document.querySelector('.js-mobile-nav');

		if (!this.nav) {
			return;
		}

		this.burger = document.querySelector('.js-mobile-navigation-button');
		this.buttons = this.nav.querySelectorAll('.js-mobile-navigation-button');
		this.panels = this.nav.querySelectorAll('.js-mobile-navigation-panel');
		this.externalClose = document.querySelectorAll('.js-mobile-navigation-close');
		this.initialised = false;

		this.addListeners();
	}

	open(panel) {
		if (panel) {
			document.body.classList.add('freeze-viewport');
			panel.setAttribute('aria-expanded', true);
		}
	}

	close(panel) {
		if (panel) {
			panel.removeAttribute('aria-expanded');
		}
	}

	closeAll() {
		this.panels.forEach((panel) => {
			document.body.classList.remove('freeze-viewport');
			this.close(panel);
		});
	}

	addListeners() {
		if (this.initialised === true) {
			return;
		}

		if (this.burger) {
			this.burger.addEventListener('click', () => {
				this.open(this.panels[0]);
			});
		}

		this.panels.forEach((panel) => {
			const backButton = panel.querySelector('.js-mobile-panel-back');
			const closeButton = panel.querySelector('.js-mobile-navigation-close');

			if (backButton) {
				backButton.addEventListener('click', (e) => {
					this.close(panel);
				});
			}

			if (closeButton) {
				closeButton.addEventListener('click', (e) => {
					this.closeAll();
				});
			}
		});

		this.externalClose.forEach((el) => {
			el.addEventListener('click', (e) => {
				this.closeAll();
			});
		});

		this.buttons.forEach((button) => {
			button.addEventListener('click', (e) => {
				e.preventDefault();
				const target = button.dataset.target;
				const panel = this.nav.querySelector(`[data-panel="${target}"]`);

				if (panel) {
					this.open(panel);
				}
			});
		});

		document.addEventListener('close-navigation', () => {
			this.closeAll();
		});

		this.initialised = true;
	}
}

const mobileNavigation = new MobileNavigation();
export default mobileNavigation;
